module.exports = __webpack_public_path__ + "img/07hot1.a65c3384.png";